export type RefreshAfterConfirmedSaveInput = Readonly<{
  /** Reloads the list or record after the backend confirmed the save. */
  refresh: () => Promise<unknown>;
  /** What was saved, as a full clause, for example "The payment was recorded". */
  savedWhat: string;
}>;

export const getSavedButNotRefreshedMessage = (savedWhat: string) =>
  `${savedWhat.trim().replace(/\.$/, "")}, but the list could not refresh. Do not record it again. Refresh the page to see the saved result before you take another action on this invoice.`;

/**
 * Runs the refresh that follows a confirmed payment, credit or invoice save.
 * The save already happened, so a refresh failure must not read as a failed
 * save: staff would click Confirm again and record it twice (UX audit G7).
 * Returns the warning to show, or null when the refresh worked.
 */
export const refreshAfterConfirmedSave = async ({
  refresh,
  savedWhat,
}: RefreshAfterConfirmedSaveInput): Promise<string | null> => {
  try {
    await refresh();
    return null;
  } catch {
    return getSavedButNotRefreshedMessage(savedWhat);
  }
};
